import React, { useState } from 'react'
import { z } from 'zod'

import { ErrorMessage, Field, Label } from '@/ui-components/Fieldset'
import { Input } from '@/ui-components/Input'

import { type CardData } from './types'

const nicknameSchema = z
  .string()
  .optional()
  .refine((val) => !val || val.length >= 2, {
    message: 'Card nickname must be at least 2 characters',
  })

type CardNicknameStepProps = {
  cardData: CardData
  setCardData: React.Dispatch<React.SetStateAction<CardData>>
}

export const CardNicknameStep = ({ cardData, setCardData }: CardNicknameStepProps) => {
  const [error, setError] = useState<string | null>(null)

  const handleNicknameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value

    try {
      nicknameSchema.parse(value)
      setError(null)
    } catch (err) {
      if (err instanceof z.ZodError) {
        setError(err.errors[0].message)
      }
    }

    setCardData((prev) => ({ ...prev, nickName: value }))
  }

  return (
    <Field>
      <Label htmlFor="nickName">Card Nickname (optional)</Label>
      <Input
        id="nickName"
        type="text"
        value={cardData.nickName}
        onChange={handleNicknameChange}
        placeholder="e.g. Charter Trips"
        autoComplete="off"
        autoFocus
        aria-invalid={!!error}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Field>
  )
}

export default CardNicknameStep
